<template>
  <div class="user">
    <ul class="clearfix">
      <!--
      <li class="user-li user-fn">
        <el-dropdown >
          <a href="javascript:;" class="user-link user-btnico">
            <span class="mng icon-guide-stroke"></span>
          </a>
          <el-dropdown-menu slot="dropdown" >
            <el-dropdown-item class="drop-list">
              <i class="mng icon-question-stroke drop-ico-pre"></i>
              <span class="drop-txt">常见问题</span>
            </el-dropdown-item>
            <el-dropdown-item class="drop-list">
              <i class="mng icon-book-stroke drop-ico-pre"></i>
              <span class="drop-txt">操作手册</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
      -->

       <li class="user-li user-fn">
         <el-badge class="user-btnico-badge" style="color:white;">
             欢迎您，{{ getUserName }}{{getUseRoleName}}（{{getloginId}}）
          </el-badge>
      </li>
      <li class="user-li user-account">
        <el-dropdown @command="handleUserCommand" >
          <a href="javascript:;" class="el-dropdown-link">
            <span class="user-portrait">
						<i class="mng icon-user-fill"></i>
					</span>
          </a>
          <el-dropdown-menu slot="dropdown" >
            <!--<el-dropdown-item class="drop-list">
              <i class="mng icon-personalData-stroke drop-ico-pre"></i>
              <span class="drop-txt">个人资料</span>
            </el-dropdown-item>-->
            <el-dropdown-item class="drop-list" command="updatePassword">
              <i class="mng icon-edit-stroke drop-ico-pre"></i>
              <span class="drop-txt">修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item class="drop-list" v-show="roleList.length >1" command="switchRole">
              <i class="mng icon-edit-stroke drop-ico-pre"></i>
              <span class="drop-txt">切换角色</span>
            </el-dropdown-item>
            <!--

            <el-dropdown-item class="drop-list" command="changeTheme">
              <i class="mng icon-theme-stroke drop-ico-pre"></i>
              <span class="drop-txt">更换皮肤</span>
            </el-dropdown-item>
             -->
            <el-dropdown-item class="drop-list"  command="loginOut" >
              <i class="mng icon-exit-stroke drop-ico-pre"></i>
              <span class="drop-txt">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>

      <li class="user-li user-fn"> 
        <a href="javascript:" @click="toggleDrawerNotice"
           class="user-link user-btnico" :style="userBtnIconStyle">
          <el-badge v-if="unreadNoticeNum > 0" class="user-btnico-badge" :value="unreadNoticeNum">
            <span class="mng icon-bell-stroke"></span>
          </el-badge>
          <span v-else class="mng icon-bell-stroke"></span>
        </a>
      </li>
    </ul>
    <switchRole ref="communitySwitch" width="40%" @loadsuccess ="getRoleList"></switchRole>
    <theme-switch ref="themeSwitch" @theme-change-success="handleThemeChangeSuccess" width="40%"></theme-switch>
    <drawer-notice ref="drawerNotice" @unread-notice-num-change="handleUnreadNoticeNumChange"></drawer-notice>
  </div>
</template>
<script>
  import util from '@/libs/util.js'
  import {STORE_APP_MUTATION_TYPES} from '../../libs/constants'
  // import {STORE_PERMISSION_MUTATION_TYPES} from '../../libs/constants'
  // import {STORE_USER_MUTATION_TYPES} from '../../libs/constants'
  import ThemeSwitch from '../theme-switch/theme-switch.vue'
  import DrawerNotice from '../drawer-notice/drawer-notice'
  import switchRole from '../../custom/components/jpcp/homepage/switchRole.vue'
  export default {
    components: {
      DrawerNotice,
      ThemeSwitch,switchRole
    },
    name: 'top-user',
    data () {
      return {
        currentUser: {},
        themeFormConfig: {
          fields: []
        },
        unreadNoticeNum: 0,
        roleList:[]
      }
    },
    created() {
      this.initUserInfo()
    },
    computed: {
      getloginId: function () {
        if (this.currentUser) {
         return this.currentUser.loginId
        }
        return ''
      },getUserName: function () {
        if (this.currentUser) {
          if (this.currentUser.trueName) {
            return this.currentUser.trueName
          }
         return this.currentUser.loginId
        }
        return '游客'
      },
      getUseRoleName: function () {
        if (this.currentUser) {
          if (this.currentUser.role) {
              if (this.currentUser.role.name) {
                  return this.currentUser.role.name;
              }
          }
        }
        return ''
      },
      userBtnIconStyle: function () {
        return {
          opacity: this.unreadNoticeNum > 0 ? 1 : 0.6
        }
      }
    },
    methods: {
      getRoleList:function(items){
        this.roleList = items;
      },
      handleUserCommand (command) {
        if (command === 'loginOut') {
          // 退出登录
          util.logout()
          // this.$store.commit(STORE_APP_MUTATION_TYPES.RESET_APP_STATE)
          // this.$store.commit(STORE_PERMISSION_MUTATION_TYPES.RESET_PERMISSION_STATE)
          // this.$store.commit(STORE_USER_MUTATION_TYPES.RESET_USER_STATE)
          // this.$router.push({name: 'login'})
          // window.location.reload()
        } else if (command === 'updatePassword') {
          this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB, {id: 'updatePassword', name: '修改密码'})
          this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, {id: 'updatePassword'})
          this.$router.push({name: 'updatePassword'})
        } else if (command === 'changeTheme') {
          this.$refs.themeSwitch.show()
        }else if (command === 'switchRole') {
             this.$refs.communitySwitch.show()
        }
      },
      initUserInfo () {
        this.$store.dispatch('GetUserInfo').then(userInfo => { // 拉取用户信息
          this.currentUser = userInfo
        }).catch((e) => {
          console.error(e)
          this.$notify.error({title: '错误', message: '用户名获取失败！'})
        })
      },
      handleThemeChangeSuccess () {
        this.$refs.themeSwitch.hide()
      },
      toggleDrawerNotice() {
        this.$refs.drawerNotice.toggle()
      },
      handleUnreadNoticeNumChange(newVal) {
        this.unreadNoticeNum = newVal
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/top-user/top-user.vue